import axios from 'axios';

let prefix = "/saga-level"

const SagaLevelApi = {
	listSagaLevel(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	listSagaLevelStat(payload) {
		return axios.get(prefix + "/list-stat", { params: payload })
	},
	getSagaLevelInfo(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	getSagaLevelStat(payload) {
		return axios.get(prefix + "/get-stat", { params: payload })
	},
	archiveSagaLevel(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createSagaLevel(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateSagaLevel(payload) {
		return axios.post(prefix + "/update", payload)
	},
	selectSagaCreepWaveGroup(payload) {
		return axios.post(prefix + "/select-creep-wave-group", payload)
	},
}

export default SagaLevelApi;